import { PAGE_TYPE } from "@/meta/common";
import type { RouteRecordRaw } from "vue-router";

export const tradeManageRouter: RouteRecordRaw[] = [
    {
        path: "/tradeManage",
        component: () => import("@/layouts/index.vue"),
        name: "TradeManage",
        meta: {
            title: "交易管理"
        },
        children: [
            {
                path: "tradeOrder",
                name: "TradeOrder",
                component: () => import("@/views/pages/tradeManage/tradeOrder/index.vue"),
                meta: {
                    title: "交易订单",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "TradeOrder",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_TRADE_ORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_TRADE_ORDER_MANAGE"
                        },
                        {
                            label: "删除",
                            value: "ROLE_TRADE_ORDER_DELETE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_TRADE_ORDER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "tradeOrder/add",
                name: "TradeOrderAdd",
                component: () => import("@/views/pages/tradeManage/tradeOrder/form.vue"),
                meta: {
                    title: "新增补录订单",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "TradeOrder",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_TRADE_ORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_TRADE_ORDER_MANAGE"
                        },
                        {
                            label: "删除",
                            value: "ROLE_TRADE_ORDER_DELETE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_TRADE_ORDER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "tradeOrder/edit",
                name: "TradeOrderEdit",
                component: () => import("@/views/pages/tradeManage/tradeOrder/form.vue"),
                meta: {
                    title: "编辑补录订单",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "TradeOrder",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_TRADE_ORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_TRADE_ORDER_MANAGE"
                        },
                        {
                            label: "删除",
                            value: "ROLE_TRADE_ORDER_DELETE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_TRADE_ORDER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "tradeOrder/detail",
                name: "TradeOrderDetail",
                component: () => import("@/views/pages/tradeManage/tradeOrder/detail.vue"),
                meta: {
                    title: "订单详情",
                    isNotShowHeader: true,
                    hidden: true,
                    activeMenu: "TradeOrder",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_TRADE_ORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_TRADE_ORDER_MANAGE"
                        },
                        {
                            label: "删除",
                            value: "ROLE_TRADE_ORDER_DELETE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_TRADE_ORDER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "tradeOrder/audit",
                name: "TradeOrderAudit",
                component: () => import("@/views/pages/tradeManage/tradeOrder/audit.vue"),
                meta: {
                    title: "审核补录订单",
                    isNotShowHeader: true,
                    hidden: true,
                    activeMenu: "TradeOrder",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_TRADE_ORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_TRADE_ORDER_MANAGE"
                        },
                        {
                            label: "删除",
                            value: "ROLE_TRADE_ORDER_DELETE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_TRADE_ORDER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "delivery/detail",
                name: "DeliveryDetail",
                component: () => import("@/views/pages/tradeManage/goodsManagement/components/delivery/detail.vue"),
                meta: {
                    title: "提货详情",
                    isNotShowHeader: true,
                    hidden: true,
                    activeMenu: "TradeOrder",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_TRADE_ORDER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_TRADE_ORDER_MANAGE"
                        },
                        {
                            label: "删除",
                            value: "ROLE_TRADE_ORDER_DELETE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_TRADE_ORDER_DEAL"
                        }
                    ]
                }
            },
            {
                path: "collectionManage",
                name: "CollectionManage",
                component: () => import("@/views/pages/tradeManage/collectionManage/index.vue"),
                meta: {
                    title: "收款管理",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "CollectionManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_RECEIVABLES_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_RECEIVABLES_DEAL"
                        },
                        {
                            label: "管理",
                            value: "ROLE_RECEIVABLES_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "collection/detail",
                name: "CollectionDetail",
                component: () => import("@/views/pages/tradeManage/collectionManage/detail.vue"),
                meta: {
                    title: "收款详情",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "CollectionManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_RECEIVABLES_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_RECEIVABLES_DEAL"
                        },
                        {
                            label: "管理",
                            value: "ROLE_RECEIVABLES_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "refundManage",
                name: "RefundManage",
                component: () => import("@/views/pages/tradeManage/refundManage/index.vue"),
                meta: {
                    title: "退款管理",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "RefundManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_REFUND_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_REFUND_MANAGE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_REFUND_DEAL"
                        }
                    ]
                }
            },
            {
                path: "refund/add",
                name: "RefundAdd",
                component: () => import("@/views/pages/tradeManage/refundManage/form.vue"),
                meta: {
                    title: "新增退款",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "RefundManage",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_REFUND_DEAL"
                        }
                    ]
                }
            },
            {
                path: "refund/edit",
                name: "RefundEdit",
                component: () => import("@/views/pages/tradeManage/refundManage/form.vue"),
                meta: {
                    title: "编辑退款",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "RefundManage",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_REFUND_DEAL"
                        }
                    ]
                }
            },
            {
                path: "refund/detail",
                name: "RefundDetail",
                component: () => import("@/views/pages/tradeManage/refundManage/detail.vue"),
                meta: {
                    title: "退款详情",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "RefundManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_REFUND_R"
                        }
                    ]
                }
            },
            {
                path: "refund/audit",
                name: "RefundAudit",
                component: () => import("@/views/pages/tradeManage/refundManage/detail.vue"),
                meta: {
                    title: "审核退款",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "RefundManage",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_REFUND_MANAGE"
                        },
                        {
                            label: "查看",
                            value: "ROLE_REFUND_R"
                        }
                    ]
                }
            },
            {
                path: "invoiceManage",
                name: "InvoiceManage",
                component: () => import("@/views/pages/tradeManage/invoiceManage/index.vue"),
                meta: {
                    title: "发票管理",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "InvoiceManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_INVOICE_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_INVOICE_DEAL"
                        }
                    ]
                }
            },
            {
                path: "invoiceDetail",
                name: "InvoiceDetail",
                component: () => import("@/views/pages/tradeManage/invoiceManage/detail.vue"),
                meta: {
                    title: " 发票详情",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "InvoiceManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_INVOICE_R"
                        }
                    ]
                }
            },
            {
                path: "invoiceAdd",
                name: "InvoiceAdd",
                component: () => import("@/views/pages/tradeManage/invoiceManage/form.vue"),
                meta: {
                    title: "新增发票",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "InvoiceManage",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_INVOICE_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];

export default tradeManageRouter;
